import cookie from 'cookie'
import {ApiConnection} from 'powtoon-api/src/apiConnection'
import webvarsConfigurationService from './webvarsConfigurationService'
import {defaultEventBus} from './producerEventBus'

const apiHost = process.env.API_HOST || webvarsConfigurationService.getWebVar('apiHost')
const cdnApiHost = process.env.CDN_API_HOST || webvarsConfigurationService.getWebVar('cdnApiHost')
const cdnPath = process.env.CDN_PATH || ''
const sessionId = process.env.SESSION_ID || webvarsConfigurationService.getWebVar('sessionId')
const csrfToken = process.env.CSRF_TOKEN || cookie.parse(document.cookie).csrftoken
const contentPermissionId = webvarsConfigurationService.getWebVar('contentPermissionId')
const licenseGeneration = webvarsConfigurationService.getWebVar('licenseGeneration')

const apiConnection = new ApiConnection({
  apiHost,
  cdnApiHost,
  cdnPath,
  sessionId,
  csrfToken,
  contentPermissionId,
  licenseGeneration,
  eventBus: defaultEventBus
})

export default apiConnection
